export default __webpack_public_path__ + "static/media/pink-circle-outline-blue-car.5814c844.png";